var _a;
export var ACCOUNT = "ACCOUNT";
export var ADMIN = "ADMIN";
export var CHANNELS = "CHANNELS";
export var DEV_TOOLS = "DEV_TOOLS";
export var HOME = "HOME";
export var INSIGHTS = "INSIGHTS";
export var INTERNAL = "INTERNAL";
export var MEDICAL = "MEDICAL";
export var MERCHANT = "MERCHANT";
export var ONBOARDING = "ONBOARDING";
export var PERKS = "PERKS";
export var PERKSGO = "PERKSGO";
export var PLATFORM = "PLATFORM";
export var PUBLIC = "PUBLIC";
export var RECOGNITION = "RECOGNITION";
export var REWARD = "REWARD";
export var SALESFORCE_PAY = "SALESFORCE";
export var CONTRACT = "CONTRACT";
export var SANDBOX = "SANDBOX";
export var SEARCH = "SEARCH";
export var SURVEY = "SURVEY";
export var SETUP_TENANT = "SETUP_TENANT";
export var WALLET = "WALLET";
export default (_a = {},
    _a[ACCOUNT] = "/account",
    _a[ADMIN] = "/admin",
    _a[CHANNELS] = "/channel",
    _a[DEV_TOOLS] = "/dev-tools",
    _a[HOME] = "/home",
    _a[INSIGHTS] = "/insights",
    _a[INTERNAL] = "/internal",
    _a[MEDICAL] = "/medical",
    _a[MERCHANT] = "/merchant",
    _a[ONBOARDING] = "/onboard",
    _a[PERKS] = "/perks",
    _a[PLATFORM] = "/",
    _a[PUBLIC] = "/public",
    _a[RECOGNITION] = "/recognition",
    _a[SALESFORCE_PAY] = "/salesforce",
    _a[CONTRACT] = "/contract",
    _a[SANDBOX] = "/sandbox",
    _a[SEARCH] = "/search",
    _a[SURVEY] = "/survey",
    _a[SETUP_TENANT] = "/setup-tenant",
    _a[WALLET] = "/wallet",
    _a);
